<template>
    <div class="dropdown-filters">
        <Dropdown 
            v-for="f in filters" 
            :key="f.label" 
            :options="f.options" 
            :selectName="f.api_field" 
            :label="f.label" 
            :selected="selectedOption(f)"
            class="full-width"
            hiddenLabel="false"
            ref="filters"></Dropdown>
    </div>
</template>

<script>
// import { filter } from 'vue/types/umd';
import { mapGetters } from 'vuex'
import Dropdown from '../components/Dropdown'

export default {
    components: {
        Dropdown
    },
    props: {
        searchType: String,
        urlLimiters: Array
    },
    computed: {
        ...mapGetters({
            'filters': 'search/refinements',
            'type': 'search/type',
            'site': 'search/site',
            'siteChanged': 'search/siteChanged',
        }),
    },
    watch: {
        'searchType': function () {
            this.populateDropdowns();
        },
        'siteChanged': {
            handler: function () {
                this.populateDropdowns();
            }
        },
        'urlLimiters' (newVal, oldVal) {
            if (newVal != oldVal && newVal.length == 0) {
                this.clearFilters();
            }
        },
    },
    methods: {
        getTerms () {
            let terms = [];
            let facetObjects = [];

            for (const filter of this.$refs.filters) {
                if (filter.selectedOption != 'all') {
                    let term = [];

                    term.push('_and', filter.selectName, filter.selectedOption)
                    terms.push(term)

                    facetObjects.push({
                        name: filter.selectName,
                        value: filter.selectedOption
                    })
                }
            }
            return {
                apiArray: terms,
                facetObjects: facetObjects
            };
        },
        clearFilters() {
            if (Object.keys(this.$refs).length == 0) return;
            for (const filter of this.$refs.filters) {
                filter.resetSelected();
            }
            
        },
        selectedOption (filter) {
            if (this.urlLimiters.length == 0) return '';
            if (this.urlLimiters.length > 0) {
                let selected = this.urlLimiters.find(l => l.key == filter.api_field);
                return selected ? selected.option : '';
            }
        },
        populateDropdowns() {
            let filters = this.$i18n.messages[this.$i18n.locale].filters || [];
            let type = this.searchType == 'all' ? 'artifact' : this.searchType;
            filters = filters.filter( filter => {
                return filter[`display_${this.site}`][type]
            })
            
            this.$store.dispatch('search/refinements',  {
                filters: filters,
                type: this.type,
                locale: this.$i18n.locale,
                site: this.site
            })
        }
    }
}
</script>

<style scoped lang="scss">

.dropdown-filters {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: $s2;
    width: 100%;
}

@media (max-width: $mq-max-width-desktop-sml) {
    .dropdown-filters {
        flex-wrap: wrap;
    }
}
</style>